import { call, put, select, takeLatest } from 'redux-saga/effects';
import i18n from 'i18next';
import { GetExchangePriceDocument, GetExchangeVariantsDocument } from '@websky/graphql';
import { createClient } from '../../../../../graphql-client';
import { FETCH_EXCHANGE_VARIANTS, FETCH_EXCHANGE_PRICE, clearExchangeVariants, setExchangeVariants, setExchangeVariantPrices, setActualSelectedFlightPriceId } from './actions';
import { setLoading, stopLoading } from '../isLoading/actions';
import { getExchangePriceParameters, getExchangeVariantsParams } from '../selectors';
import { setError } from '../error/actions';
import { getGqlErrorMessage } from '@shared/lib/getGqlErrorMessage';
function getExchangeVariantsQuery(params) {
    const client = createClient();
    return client.mutate({
        mutation: GetExchangeVariantsDocument,
        variables: { params },
        fetchPolicy: 'no-cache'
    });
}
function getExchangePrice(params) {
    const client = createClient();
    return client.mutate({
        mutation: GetExchangePriceDocument,
        variables: { params },
        fetchPolicy: 'no-cache'
    });
}
function* fetchExchangeVariants() {
    var _a, _b, _c, _d, _e;
    const exchangeVariantsParams = yield select(getExchangeVariantsParams);
    yield put(clearExchangeVariants());
    yield put(setLoading('exchange-variants'));
    try {
        const exchangeVariants = yield call(getExchangeVariantsQuery, exchangeVariantsParams);
        if (!((_a = exchangeVariants === null || exchangeVariants === void 0 ? void 0 : exchangeVariants.data) === null || _a === void 0 ? void 0 : _a.GetExchangeVariants) || ((_b = exchangeVariants.errors) === null || _b === void 0 ? void 0 : _b.length)) {
            throw new Error((_d = (_c = exchangeVariants.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message);
        }
        yield put(setExchangeVariants({
            flightDirections: exchangeVariants.data.GetExchangeVariants.flightDirections,
            exchangeVariantPriceInfo: ((_e = exchangeVariants.data.GetExchangeVariants) === null || _e === void 0 ? void 0 : _e.exchangeVariantPriceInfo) || []
        }));
    }
    catch (err) {
        const errorMessage = i18n.t(getGqlErrorMessage(err), { ns: 'Exchange' });
        yield put(setError(errorMessage));
    }
    yield put(stopLoading());
}
export function* fetchExchangePrice() {
    var _a, _b, _c, _d;
    const exchangePriceParams = yield select(getExchangePriceParameters);
    yield put(setLoading('exchange-price'));
    try {
        const exchangePrice = yield call(getExchangePrice, exchangePriceParams);
        if (!((_a = exchangePrice.data) === null || _a === void 0 ? void 0 : _a.ExchangePrice) || ((_b = exchangePrice.errors) === null || _b === void 0 ? void 0 : _b.length)) {
            throw new Error((_d = (_c = exchangePrice.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message);
        }
        const exchangeVariantPriceInfo = exchangePrice.data.ExchangePrice.exchangeVariantPriceInfo || [];
        const lastExchangeVariantPrice = exchangeVariantPriceInfo[exchangeVariantPriceInfo.length - 1];
        yield put(setActualSelectedFlightPriceId({
            priceId: exchangePriceParams.flightId,
            actualPriceId: lastExchangeVariantPrice.flightId
        }));
        yield put(setExchangeVariantPrices(exchangePrice.data.ExchangePrice.exchangeVariantPriceInfo));
    }
    catch (err) {
        const errorMessage = i18n.t(getGqlErrorMessage(err), { ns: 'Exchange' });
        yield put(setError(errorMessage));
    }
    yield put(stopLoading());
}
export function* exchangeVariantsSagas() {
    yield takeLatest(FETCH_EXCHANGE_VARIANTS, fetchExchangeVariants);
    yield takeLatest(FETCH_EXCHANGE_PRICE, fetchExchangePrice);
}
